import { render, staticRenderFns } from "./SettingGeneral.vue?vue&type=template&id=527851ec&scoped=true"
import script from "./SettingGeneral.vue?vue&type=script&lang=js"
export * from "./SettingGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingGeneral.vue?vue&type=style&index=0&id=527851ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527851ec",
  null
  
)

export default component.exports